import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdatePlatformBunnySettingsMutation } from "../graphql/mutations";
import type {
  UpdatePlatformBunnySettingsMutationType,
  UpdatePlatformBunnySettingsMutationVariablesType,
} from "@/types/graphql/admin.generated";

export function useUpdatePlatformBunnySettingsMutation(
  options?: MutationHookOptions<
    UpdatePlatformBunnySettingsMutationType,
    UpdatePlatformBunnySettingsMutationVariablesType
  >
) {
  return useMutation<
    UpdatePlatformBunnySettingsMutationType,
    UpdatePlatformBunnySettingsMutationVariablesType
  >(UpdatePlatformBunnySettingsMutation, options);
}
